import * as React from 'react';

const MOBILE_BREAKPOINT = 1024;

export function useIsMobile() {
	const [isMobile, setIsMobile] = React.useState(() => {
		if (typeof window === 'undefined') return false;
		return window.innerWidth < MOBILE_BREAKPOINT;
	});

	React.useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
		const onChange = () => {
			setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
		};
		mql.addEventListener('change', onChange);
		return () => mql.removeEventListener('change', onChange);
	}, []);

	return isMobile;
}

const isMobileSafariBrowser = () => {
	if (typeof navigator === 'undefined') return false;

	const { userAgent, platform, maxTouchPoints } = navigator;
	const isAppleMobile =
		/iP(ad|hone|od)/i.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1);
	const isSafari = /Safari/i.test(userAgent);
	const isOtherIosBrowser = /CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/i.test(userAgent);

	return isAppleMobile && isSafari && !isOtherIosBrowser;
};

export function useIsMobileSafari() {
	const [isMobileSafari, setIsMobileSafari] = React.useState(isMobileSafariBrowser);

	React.useEffect(() => {
		setIsMobileSafari(isMobileSafariBrowser());
	}, []);

	return isMobileSafari;
}
